<template>
  <div class="lstIzin">
    <div class="col-12 py-2 px-2">
      <a href="/list-cuti-bersama" class="btn btn-warning cuti">
        Jumlah Cuti Bersama Tahun Ini : {{ cuti_bersama }}
      </a>
    </div>
    <div class="col-12 px-2" v-show="sisa_thn_kemaren < 0">
      <a class="btn btn-success sisa">
        Sisa Cuti Tahun {{ backYear }} : {{ sisa_thn_kemaren }}
      </a>
    </div>
    <div class="col-12">
      <div class="list-group">
        <div v-for="(item, index) in listOfizin" :key="index" class="py-1 px-2">
          <a
            v-if="item.status == 1"
            v-bind:href="`/pdfcuti?nama=${nama}&awal=${item.tanggal_awal_cuti}&akhir=${item.tanggal_akhir_cuti}&masuk=${item.tanggal_masuk}&ket=${item.keterangan}&kontak=${kontak}&now=${tglsaatini}`"
            class="list-group-item list-group-item-action"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Pengajuan Cuti</h5>
              <small class="text-muted">{{
                formatDate(item.created_on)
              }}</small>
            </div>
            <p class="mb-1">
              Tanggal Awal Cuti : {{ formatDate(item.tanggal_awal_cuti) }}
            </p>
            <p class="mb-1">
              Tanggal Akhir Cuti : {{ formatDate(item.tanggal_akhir_cuti) }}
            </p>
            <p class="mb-1">Lama Cuti : {{ item.total_cuti_diambil }} hari</p>
            <small class="text-muted" v-if="item.status == 0">Pending</small>
            <small class="text-success" v-else-if="item.status == 1"
              >Disetujui</small
            >
            <small class="text-danger" v-else>Tidak Disetujui</small>
          </a>
          <a v-else href="#" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Pengajuan Cuti</h5>
              <small class="text-muted">{{ item.created_on }}</small>
            </div>
            <p class="mb-1">
              Tanggal Awal Cuti : {{ formatDate(item.tanggal_awal_cuti) }}
            </p>
            <p class="mb-1">
              Tanggal Akhir Cuti : {{ formatDate(item.tanggal_akhir_cuti) }}
            </p>
            <p class="mb-1">Lama Cuti : {{ item.total_cuti_diambil }} hari</p>
            <small class="text-muted" v-if="item.status == 0">Pending</small>
            <small class="text-success" v-else-if="item.status == 1"
              >Disetujui</small
            >
            <small class="text-danger" v-else>Tidak Disetujui</small>
          </a>
        </div>
        <button
          type="button"
          class="btn btn-succes btn-sm"
          :class="{ 'd-none': btnDisabled }"
          @click.prevent="loadMore(page)"
        >
          {{ btnLoadMoreName }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios");
const Swal = require("sweetalert2");
import moment from "moment";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + sessionStorage.getItem("key"),
};
export default {
  data() {
    return {
      page: 2,
      id: localStorage.getItem("id"),
      listOfizin: [],
      dataEmpty: true,
      btnDisabled: false,
      btnLoadMoreName: "Muat Lebih Banyak",
      nama: localStorage.getItem("nama"),
      kontak: "xxxxxxx",
      tglsaatini: new Date().toISOString().slice(0, 10),
      cuti_bersama: null,
      sisa_thn_kemaren: 0,
      backYear: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    loadMore(pages) {
      try {
        axios
          .post(
            this.UrlApi + "listcuti?page=" + pages,
            {
              id: this.id,
            },
            { headers: headers }
          )
          .then((res) => {
            if (res.data.success && res.data.success !== null) {
              // this.dataEmpty = res.data.data.length > 0 ? true : false;
              if (res.data.data.length > 0) {
                this.page += 1;
                Array.prototype.push.apply(this.listOfizin, res.data.data);
                // console.log(this.listOfizin);
              } else {
                this.btnLoadMoreName = "Data Sudah Diload Seluruhnya";
                this.btnDisabled = true;
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: res.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
  created() {
    var count = localStorage.getItem("ijin");
    count = JSON.parse(count);
    Object.keys(count).forEach((key) => {
      this.cuti_bersama = count[key].cuti_bersama;
      this.sisa_thn_kemaren = count[key].cuti_tahun_kemarin;
    });

    var date = new Date().getFullYear();
    this.backYear = date - 1;

    try {
      axios
        .post(
          this.UrlApi + "listcuti?page=",
          {
            id: this.id,
          },
          { headers: headers }
        )
        .then((res) => {
          if (res.data.success && res.data.success !== null) {
            this.dataEmpty = res.data.data.length > 0 ? true : false;
            this.listOfizin = res.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("error response");
          } else if (err.request) {
            console.log("error request");
          } else {
            console.log("error");
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
